export class TagReportRequestModel {
    constructor() {
        this.startDate = "";
        this.endDate = "";
        this.teamId = "";
        this.tagIds = [];
    }
}
export default class TagReportRequest extends TagReportRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
